// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"24c3a7a1","239":"e1e351ef","389":"9b461952","450":"93f9abd7","453":"a8bf61dc","455":"ce63663e","977":"135a0cd5"}[chunkId] + ".chunk.js";
};